import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { Input } from '../../components-v2/Input';
import { styleSheet } from './styles';

interface IProps extends Omit<React.ComponentProps<'input'>, 'styles'> {
	label?: React.ReactNode;
	labelStyles?: StyleDeclarationValue[];
	styles?: StyleDeclarationValue[];
	/** @deprecated Use id instead */
	inputId?: string;
	/** @deprecated No replacement — callers in P1c/P1d remove this prop */
	inputClassName?: string;
}

export const TextInputFormField: React.FC<IProps> = props => {
	const { className, label, styles = [], labelStyles = [], inputId, inputClassName: _ic, id, ...restProps } = props;
	return (
		<div className={`${css(styleSheet.container, ...styles)} text-input-form-field ${className || ''}`}>
			{!!label && <div className={`text-input-form-field-label ${css(styleSheet.label, ...labelStyles)}`}>{label}</div>}
			<Input id={id ?? inputId} {...restProps} />
		</div>
	);
};
